import { Link } from "react-router-dom";
import { Mail, Phone, Instagram, MapPin } from "lucide-react";
import { PRACTITIONER } from "../lib/api";

export default function Footer() {
  return (
    <footer className="mt-24" style={{ background: "var(--bg-secondary)", borderTop: "1px solid var(--border-soft)" }} data-testid="site-footer">
      <div className="container-soft py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-display text-3xl mb-3" style={{ color: "var(--text-primary)" }}>Sudiksha Kulharia</div>
          <p className="text-sm leading-relaxed max-w-md" style={{ color: "var(--text-secondary)" }}>
            A safe, empathetic, and non-judgmental space for individuals seeking emotional support and personal growth.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] mb-4" style={{ color: "var(--primary-deep)" }}>Explore</div>
          <ul className="space-y-2 text-sm" style={{ color: "var(--text-secondary)" }}>
            <li><Link to="/about" className="hover:underline">About</Link></li>
            <li><Link to="/services" className="hover:underline">Services</Link></li>
            <li><Link to="/booking" className="hover:underline">Book a Session</Link></li>
            <li><Link to="/blog" className="hover:underline">Blog</Link></li>
            <li><Link to="/faq" className="hover:underline">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] mb-4" style={{ color: "var(--primary-deep)" }}>Reach Out</div>
          <ul className="space-y-3 text-sm" style={{ color: "var(--text-secondary)" }}>
            <li className="flex items-center gap-2"><Mail size={14}/> <a href={`mailto:${PRACTITIONER.email}`} className="hover:underline">{PRACTITIONER.email}</a></li>
            <li className="flex items-center gap-2"><Phone size={14}/> {PRACTITIONER.phone}</li>
            <li className="flex items-center gap-2"><Instagram size={14}/> <a href={PRACTITIONER.instagramUrl} target="_blank" rel="noreferrer" className="hover:underline">@{PRACTITIONER.instagram}</a></li>
            <li className="flex items-center gap-2"><MapPin size={14}/> {PRACTITIONER.city}</li>
          </ul>
        </div>
      </div>
      <div className="border-t py-6 text-center text-xs" style={{ borderColor: "var(--border-soft)", color: "var(--text-secondary)" }}>
        © {new Date().getFullYear()} Sudiksha Kulharia — Psychologist & Counsellor. All rights reserved.
      </div>
    </footer>
  );
}
